module.exports = __webpack_public_path__ + "static/img/ARAS800N_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAS800N_1.png
// module id = yYBN
// module chunks = 0